import React from 'react'

export interface DateRangePickerContextValue {
  start: string | null
  end: string | null
  onSelect(date: string): unknown

  transitionState: 'none' | 'toNext' | 'toPrev' | 'init'

  goToNextMonth(): unknown
  goToPreviousMonth(): unknown

  selectionPreview: { start: string; end: string } | null
  setMouseOver(date: string | null): unknown
  shouldDisableDate(date: string): boolean
  shouldDisableStartDate(date: string, endDate: string | null): boolean
  shouldDisableEndDate(endDate: string, startDate: string | null): boolean

  currentField: 'start' | 'end' | null
}

export const DateRangePickerContext = React.createContext<null | DateRangePickerContextValue>(null)

export type DateRangePickerRootProps = { children?: React.ReactNode; value: DateRangePickerContextValue }

export function DateRangePickerRoot({ children, value }: DateRangePickerRootProps) {
  return <DateRangePickerContext.Provider value={value}>{children}</DateRangePickerContext.Provider>
}
